import allLocales from 'shared/constants/locales.js';

const normalizeCodeForDisplay = code => code?.replace(/_/g, '-');

const capitalizeFirstLetter = value => {
  if (!value) return value;
  return value.charAt(0).toLocaleUpperCase() + value.slice(1);
};

export const localizedLocaleName = (code, displayLocale, fallback) => {
  const normalizedCode = normalizeCodeForDisplay(code);
  const normalizedDisplayLocale = normalizeCodeForDisplay(displayLocale);

  if (!allLocales[code]) {
    return fallback || code;
  }

  if (normalizedDisplayLocale?.startsWith('en')) {
    return fallback || allLocales[code];
  }

  try {
    const displayNames = new Intl.DisplayNames([normalizedDisplayLocale], {
      type: 'language',
    });
    return capitalizeFirstLetter(displayNames.of(normalizedCode));
  } catch {
    return fallback || allLocales[code] || code;
  }
};

export const localizedLocaleOption = (code, displayLocale, metadata = {}) => ({
  ...metadata,
  id: code,
  name: localizedLocaleName(code, displayLocale),
  code,
});
